import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getInstruktur = 'instruktur';
const getInstrukturUrl = 'instruktur/';
const getInstrukturAll = 'instruktur-select';
const postInstrukturUrl = 'instruktur';
const putInstruktur = 'instruktur/';
const deleteInstruktur = 'instruktur/';

class InstrukturService {
    getInstruktur(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getInstruktur + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }
    getInstrukturAll() {
        return axios.get(
            API_URL + getInstrukturAll , {
                headers: authHeader()
            });
    }

    getInstrukturUrl(idInstruktur) {
        return axios.get(
            API_URL + getInstrukturUrl + idInstruktur,
            {
                headers: authHeader()
            });
    }

    postInstruktur(formData) {  
        var form = new FormData();
        form.append("namaInstruktur", formData.namaInstruktur);
        form.append("idAnggota", formData.idAnggota);
        form.append("kategoriAnggota", formData.kategoriAnggota);
        form.append("npwp", formData.npwp);
        form.append("noTelepon", formData.noTelepon);
        form.append("alamat", formData.alamat);
        form.append("email", formData.email);
        form.append("instansi", formData.instansi);
        form.append("namaBank", formData.namaBank);
        form.append("nomorRekening", formData.nomorRekening);
        form.append("tipeInstruktur", formData.tipeInstruktur);
        if (formData.cv !== "") {
            form.append('cv', formData.cv);
        }
        form.append("status", formData.status);
              
        return axios
        .post(
            API_URL + postInstrukturUrl,
            form,
            { headers: authHeader() }
        );
    }

    putInstruktur(formData) {  
        var form = new FormData();
        form.append("namaInstruktur", formData.namaInstruktur);
        form.append("idAnggota", formData.idAnggota);
        form.append("kategoriAnggota", formData.kategoriAnggota);
        form.append("npwp", formData.npwp);
        form.append("noTelepon", formData.noTelepon);
        form.append("alamat", formData.alamat);
        form.append("email", formData.email);
        form.append("namaBank", formData.namaBank);
        form.append("nomorRekening", formData.nomorRekening);
        form.append("instansi", formData.instansi);
        form.append("tipeInstruktur", formData.tipeInstruktur);
        if (typeof formData.cv !== 'undefined') {
            form.append('cv', formData.cv);
        }
        form.append("status", formData.status);
              
        return axios
        .put(
            API_URL + putInstruktur + formData.idInstruktur,
            form,
            { headers: authHeader() }
        );
    }

    // putInstruktur(formData) {
    //     var headers = authHeader(); 

    //     return axios
    //     .put(
    //         API_URL + putInstruktur + formData.idInstruktur, formData,
    //         { headers: authHeader() }
    //     );
    // }

    deleteInstruktur(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteInstruktur + formData.idInstruktur,
                { headers: authHeader() }
            );
    }

}

export default new InstrukturService();